import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AppIcon } from './AppIcon';
interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
  }>;
}
export function InstallPrompt() {
  const [showBanner, setShowBanner] = useState(false);
  const deferredPromptRef = useRef<BeforeInstallPromptEvent | null>(null);
  useEffect(() => {
    // Don't show if already installed as PWA
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    // Don't show if user previously dismissed
    if (localStorage.getItem('bella_install_dismissed')) return;
    const handleBeforeInstall = (e: Event) => {
      e.preventDefault();
      deferredPromptRef.current = e as BeforeInstallPromptEvent;
      // Show banner after 2 second delay
      setTimeout(() => {
        setShowBanner(true);
      }, 2000);
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);
  const handleInstall = async () => {
    if (!deferredPromptRef.current) return;
    try {
      await deferredPromptRef.current.prompt();
      const {
        outcome
      } = await deferredPromptRef.current.userChoice;
      if (outcome === 'dismissed') {
        localStorage.setItem('bella_install_dismissed', 'true');
      }
    } catch (err) {
      // Silent: install prompt error
    }
    setShowBanner(false);
    deferredPromptRef.current = null;
  };
  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('bella_install_dismissed', 'true');
  };
  return <AnimatePresence data-id="element-267" data-mp="25kid09l28qqj">
      {showBanner && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed z-[9998] left-1/2 -translate-x-1/2 w-[calc(100%-32px)] max-w-[380px] bottom-[80px] md:bottom-[16px]" data-id="element-268" data-mp="25ljrko1abvd0">
          <div className="bg-white rounded-[20px] shadow-[0_-4px_24px_rgba(107,33,232,0.15)] p-4 flex items-center gap-3" data-id="element-269" data-mp="1obxxn2kys3ht">
            <AppIcon size={40} className="flex-shrink-0" data-id="element-270" data-mp="1t7db3tf27xdp" />

            <div className="flex-1 min-w-0" data-id="element-271" data-mp="2h03jxtro20jr">
              <h4 className="text-[14px] font-semibold text-text-primary" data-id="element-272" data-mp="2gx7m05ftjbvb">
                Add Aurora Care to Home Screen
              </h4>
              <p className="text-[12px] text-text-secondary" data-id="element-273" data-mp="271npphxceb61">
                Install for the best experience
              </p>
            </div>

            <div className="flex items-center gap-2 flex-shrink-0" data-id="element-274" data-mp="2c220v8u8q18a">
              <button onClick={handleInstall} className="bg-primary text-white text-[13px] font-medium px-[14px] py-[6px] rounded-pill hover:bg-primary/90 transition-colors" data-id="element-275" data-mp="vkxrom32opni">
                Install
              </button>
              <button onClick={handleDismiss} className="text-text-secondary text-[13px] font-medium px-2 py-[6px]" data-id="element-276" data-mp="39tzyr616n21v">
                Not now
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}